import { DefaultTabItem } from '@libs/components';
import { CurrencyType, RealFiatAssets } from '@libs/types';

type BalanceCurrencyOptionType = DefaultTabItem & { value: RealFiatAssets };

export const balanceCurrencyOptions: BalanceCurrencyOptionType[] = [
  {
    id: '1',
    value: CurrencyType.GEL,
    title: '₾',
  },
  {
    id: '2',
    value: CurrencyType.USD,
    title: '$',
  },
];
